<app-progress-bar-overlay></app-progress-bar-overlay>
<h2 mat-dialog-title>Opzioni di caricamento</h2>

<div>
  @if (isSingle) {
    <div class="content">
      <p>
        <strong>{{ fileName }}</strong> esiste già in questa posizione.
      </p>
      <p>
        Vuoi <strong>sostituire il file esistente</strong> oppure
        <strong>conservare entrambi i file</strong>?
      </p>
    </div>
  }
  @if (!isSingle) {
    <div class="content">
      <p>Uno o più elementi esistono già in questa posizione.</p>
      <p>
        Vuoi <strong>sostituire gli elementi esistenti</strong> oppure
        <strong>conservare entrambi gli elementi</strong>?
      </p>
    </div>
  }

  <mat-radio-group [(ngModel)]="selectedOption">
    @if (isSingle) {
      <!-- Opzione singolo file -->
      <mat-radio-button value="replace"> Sostituisci file esistente </mat-radio-button>

      <mat-radio-button value="keep"> Conserva entrambi i file </mat-radio-button>
    } @else {
      <!-- Opzione multipli -->
      <mat-radio-button value="replace"> Sostituisci elementi esistenti </mat-radio-button>

      <mat-radio-button value="keep"> Conserva tutti gli elementi </mat-radio-button>
    }
  </mat-radio-group>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Carica
    </button>
  </div>
</div>
